import { AnsweredQuestion, QuizMapping } from '@puls/puls-common-constants';
import { MutationTree } from 'vuex';
import { AnswerQuestionPayload } from './actions';
import { skillAssessmentUtils } from '@puls/puls-general-utils';

export const QuizMutations = {
	UPDATE_QUIZ_MAPPING: 'UPDATE_QUIZ_MAPPING',
	UPDATE_QUESTION_ANSWER: 'UPDATE_QUESTION_ANSWER',
	EXPIRE_CURRENT_QUIZ: 'EXPIRE_CURRENT_QUIZ'
};

export const mutations: MutationTree<any> = {
	[QuizMutations.UPDATE_QUIZ_MAPPING] (state: QuizMapping, payload: QuizMapping) {
		Object.assign(state, payload);
	},
	[QuizMutations.UPDATE_QUESTION_ANSWER] (state: QuizMapping, payload: AnswerQuestionPayload) {
		const currentQuiz = skillAssessmentUtils.getAttemptCurrentQuiz(state.quizes);
		if (currentQuiz) {
			const question = currentQuiz.questions.find(q => q.uuid === payload.uuid) as AnsweredQuestion;
			if (question) {
				question.answers = payload.answers;
			}	
		}
	},
	[QuizMutations.EXPIRE_CURRENT_QUIZ] (state: QuizMapping) {
		const currentQuiz = skillAssessmentUtils.getAttemptCurrentQuiz(state.quizes);
		if (currentQuiz) {
			currentQuiz.current_time = (currentQuiz.start_time || 0) + (state.quiz_metadata.quiz_duration_minutes * 60 * 1000)
		}
	}
}
